export const onespMenus = () => ({
  id: `main-menu-2-all`,
  path: '/management/e-appilcations/community/communities',
  label: 'ONE Cloud',
  Description: 'E-Apps can also track and observe Employee, Finance etc and use it to offer custom recommendations and updates to the users. Furthermore.',
  isEnabled: true,
  svg: (
    <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M20 3h-3V2H7v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V7h16v14zm-6-9h-4v-1h4v1zm-6 2h6v1H8v-1zm6-4H8v-1h6v1z" />
      </g>
    </svg>

  ),

  subMenu: [
    {
      id: `main-menu-2-all`,
      path: '/management/e-applications/onesp/one-service-provider',
      label: 'ONESP',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },

    {
      id: `main-menu-2-all`,
      path: '/management/e-applications/onesp/ventures',
      label: 'Ventures',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },

    {
      id: `main-menu-2-all`,
      path: '/management/onesp/oneuser',
      label: 'ONE User',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: []
    },

    {
      id: `main-menu-2-all`,
      path: '/management/onesp/candidates',
      label: 'Candidates',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: []
    },

    {
      id: `main-menu-2-all`,
      path: '/management/e-appilcations/community/communities',
      label: 'Connect-X',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Communities',
          path: '/management/e-appilcations/community/communities',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
         {
          id: `coln-1-Categories`,
          label: 'Subscriptions',
          path: '/management/e-appilcations/community/subscriptions',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Chapters',
          path: '/management/onesp/chapters/chapter',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
          subMenu: [
            {
              id: `coln-1-Categories`,
              label: 'Chapter',
              path: '/management/onesp/chapters/chapter',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Feeds',
              path: '/management/onesp/chapters/feeds',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Posts',
              path: '/management/onesp/chapters/posts',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Comments',
              path: '/management/onesp/chapters/comments',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
            {
              id: `coln-1-Categories`,
              label: 'Subscriptions',
              path: '/management/onesp/chapters/subscriptions',
              isEnabled: true,
              svg: (
                <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                    <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                    <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
                  </g> </g>
                </svg>
              ),
            },
          ],
        },
       

        // {
        //   id: `coln-1-Categories`,
        //   label: 'Forums',
        //   path: '/management/e-applications/forum/forum-group',
        //   isEnabled: true,
        //   svg: (
        //     <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //       <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //       <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
        //         <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
        //         <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
        //       </g> </g>
        //     </svg>
        //   ),
        //   subMenu: [
        //     {
        //       id: `coln-1-Categories`,
        //       label: 'Groups',
        //       path: '/management/e-applications/forum/forum-group',
        //       isEnabled: true,
        //       svg: (
        //         <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //           <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //           <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
        //             <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
        //             <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
        //           </g> </g>
        //         </svg>
        //       ),
        //     },
        //     {
        //       id: `coln-1-Categories`,
        //       label: 'Forums',
        //       path: '/management/e-applications/forum/forums',
        //       isEnabled: true,
        //       svg: (
        //         <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //           <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //           <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
        //             <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
        //             <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
        //           </g> </g>
        //         </svg>
        //       ),
        //     },
        //     {
        //       id: `coln-1-Categories`,
        //       label: 'Topics',
        //       path: '/management/e-applications/forum/forum-topics',
        //       isEnabled: true,
        //       svg: (
        //         <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //           <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //           <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
        //             <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
        //             <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
        //           </g> </g>
        //         </svg>
        //       ),
        //     },
        //     {
        //       id: `coln-1-Categories`,
        //       label: 'Posts',
        //       path: '/management/e-applications/forum/forum-posts',
        //       isEnabled: true,
        //       svg: (
        //         <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //           <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //           <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
        //             <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
        //             <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
        //           </g> </g>
        //         </svg>
        //       ),
        //     },
        //     {
        //       id: `coln-1-Categories`,
        //       label: 'Subscriptions',
        //       path: '/management/e-applications/forum/forum-subscriptions',
        //       isEnabled: true,
        //       svg: (
        //         <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        //           <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        //           <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
        //             <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
        //             <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
        //           </g> </g>
        //         </svg>
        //       ),
        //     },
        //   ],
        // },



      ],
    },



    {
      id: `main-menu-2-all`,
      path: '/management/e-applications/event/events',
      label: 'Events Management',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Events',
          path: '/management/e-applications/event/events',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },

        {
          id: `coln-1-Categories`,
          label: 'Tickets',
          path: '/management/e-applications/event/event-tickets',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Booking',
          path: '/management/e-applications/event/event-bookings',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },


      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/management/e-applications/lms/collections',
      label: 'LMS',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Collections',
          path: '/management/e-applications/lms/collections',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'LearningPaths',
          path: '/management/e-applications/lms/learning-paths',
          isEnabled: true,
          svg: (
            <svg fill="#ffffff" className="h-5 w-5 fill-current mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 490 490">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g>
                <path d="M463.648,0H26.353C11.799,0,0,12.09,0,27.003v329.454c0,14.914,11.799,27.004,26.353,27.004h50.82L45.217,490 l149.871-102.284c4.294-2.887,9.319-4.425,14.456-4.425h254.105c14.554,0,26.352-12.09,26.352-27.003V27.003 C490,12.09,478.202,0,463.648,0z M459.375,352.666H209.543c-11.259,0-22.166,3.332-31.719,9.754l-78.421,53.52l7.103-23.68 l11.826-39.423h-41.16H30.625V30.625h428.75V352.666z"></path> <path d="M245,303.932c23.237-12.295,46.297-16.393,66.714-16.393c40.835,0,71.099,16.393,71.099,16.393V96.541 c-23.034-12.42-46.072-16.555-66.532-16.555C275.534,79.987,245,96.38,245,96.38s-30.54-16.391-71.279-16.393 c-20.464-0.001-43.493,4.133-66.532,16.555v207.391c0,0,30.27-16.393,71.099-16.393C198.706,287.539,221.759,291.636,245,303.932z M352.188,116.457v144.795c-11.846-2.533-25.532-4.337-40.474-4.337c-17.766,0-34.954,2.596-51.406,7.677V122.969 c4.546-2.181,27.279-12.357,55.972-12.357C328.819,110.612,340.838,112.573,352.188,116.457z M137.813,116.457 c11.351-3.885,23.368-5.846,35.906-5.845c29.059,0.002,51.96,10.415,55.964,12.348v141.628 c-16.448-5.079-33.633-7.673-51.396-7.673c-14.942,0-28.627,1.805-40.474,4.338V116.457z"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Courses',
          path: '/management/e-applications/lms/courses',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1 2h16v11H1z"></path>
                <path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M4 5.5v5s3-1 5 0v-5s-2-2-5 0zM9 5.5v5s3-1 5 0v-5s-2-2-5 0z"></path>
                <path fill="none" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8.5 14l-3 3h7l-3-3z"></path>
              </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Modules',
          path: '/management/e-applications/lms/modules',
          isEnabled: true,
          svg: (
            <svg fill="#ffffff" className="h-5 w-5 fill-current mr-2" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M1581.176 1072.47h-225.882v438.551l-366.833 213.685c-17.506 10.278-39.416 10.278-56.922 0L564.706 1511.02v-438.55H338.824V685.647c0-20.103 10.842-38.739 28.009-48.79l310.814-181.045v164.894h564.706V455.812l310.814 181.044c17.167 10.052 28.01 28.688 28.01 48.791v386.824Zm112.942 0V685.648c0-60.085-32.189-116.216-84.142-146.485L1242.353 325.14V56H677.647v269.139L310.024 539.162c-51.953 30.269-84.142 86.4-84.142 146.485v386.824H0v564.705h557.026l317.703 185.111c26.429 15.36 55.68 23.04 85.271 23.04 29.59 0 58.955-7.68 85.27-23.04l317.704-185.11H1920V1072.47h-225.882Z" fill-rule="evenodd"></path>
              </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Chapters',
          path: '/management/e-applications/lms/chapters',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M0 0h48v48H0z" fill="none"></path>
                <g id="Shopicon">
                  <rect x="16.002" y="22.002" width="25.997" height="4"></rect>
                  <rect x="16.002" y="11.995" width="25.997" height="4"></rect>
                  <rect x="16.002" y="32.008" width="25.997" height="4"></rect>
                  <rect x="6" y="12" width="4" height="4"></rect>
                  <rect x="6" y="22.006" width="4" height="4"></rect>
                  <rect x="6" y="32.013" width="4" height="4"></rect>
                </g> </g>
            </svg>
          ),
        },

        {
          id: `coln-1-Categories`,
          label: 'Topics',
          path: '/management/e-applications/lms/topics',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fill-rule="evenodd" d="M20 10a1 1 0 0 1-1 1h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 1 1zM7 14.019zm5 2.001a1 1 0 0 1-1 1 1.021 1.021 0 0 1-.79-.38l-.04-.06A6.177 6.177 0 0 0 7 14.15 3.663 3.663 0 0 0 6 14v1.02a.976.976 0 0 1-.55.87 1 1 0 0 1-1.05-.09l-4-3a1 1 0 0 1 0-1.6l4-3a.99.99 0 0 1 1.05-.09.988.988 0 0 1 .55.87V10c2.15 0 5.91 3.1 6 6.02zM20 14a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0 4a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0-12a1 1 0 0 1-1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1z"></path>
                <path fill="#ffffff" fill-rule="evenodd" d="M24 2v20a2.006 2.006 0 0 1-2 2H8a2.006 2.006 0 0 1-2-2v-3a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-19a.487.487 0 0 0-.49-.5H8.5a.5.5 0 0 0-.5.5V5a1 1 0 0 1-2 0V2a2.006 2.006 0 0 1 2-2h14a2.006 2.006 0 0 1 2 2z"></path>
              </g>
            </svg>
          ),
        },
         {
          id: `coln-1-Categories`,
          label: 'Enrollments',
          path: '/management/e-applications/lms/enrollments',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fill-rule="evenodd" d="M20 10a1 1 0 0 1-1 1h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 1 1zM7 14.019zm5 2.001a1 1 0 0 1-1 1 1.021 1.021 0 0 1-.79-.38l-.04-.06A6.177 6.177 0 0 0 7 14.15 3.663 3.663 0 0 0 6 14v1.02a.976.976 0 0 1-.55.87 1 1 0 0 1-1.05-.09l-4-3a1 1 0 0 1 0-1.6l4-3a.99.99 0 0 1 1.05-.09.988.988 0 0 1 .55.87V10c2.15 0 5.91 3.1 6 6.02zM20 14a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0 4a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1zm0-12a1 1 0 0 1-1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1z"></path>
                <path fill="#ffffff" fill-rule="evenodd" d="M24 2v20a2.006 2.006 0 0 1-2 2H8a2.006 2.006 0 0 1-2-2v-3a1 1 0 0 1 2 0v2.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-19a.487.487 0 0 0-.49-.5H8.5a.5.5 0 0 0-.5.5V5a1 1 0 0 1-2 0V2a2.006 2.006 0 0 1 2-2h14a2.006 2.006 0 0 1 2 2z"></path>
              </g>
            </svg>
          ),
        },

        {
          id: `coln-1-Categories`,
          label: 'Channels',
          path: '/management/e-applications/lms/channels',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M3 8.5C3 7.67157 3.67157 7 4.5 7H13V10H4.5C3.67157 10 3 9.32843 3 8.5V8.5Z" fill="#ffffff"></path>
                <path d="M14 7H19.5C20.3284 7 21 7.67157 21 8.5V8.5C21 9.32843 20.3284 10 19.5 10H14V7Z" fill="#ffffff"></path>
                <path d="M3 12.5C3 11.6716 3.67157 11 4.5 11H10V14H4.5C3.67157 14 3 13.3284 3 12.5V12.5Z" fill="#ffffff"></path>
                <path d="M11 11H19.5C20.3284 11 21 11.6716 21 12.5V12.5C21 13.3284 20.3284 14 19.5 14H11V11Z" fill="#ffffff"></path>
                <path d="M3 16.5C3 15.6716 3.67157 15 4.5 15H16V18H4.5C3.67157 18 3 17.3284 3 16.5V16.5Z" fill="#ffffff"></path>
                <path d="M17 15H19.5C20.3284 15 21 15.6716 21 16.5V16.5C21 17.3284 20.3284 18 19.5 18H17V15Z" fill="#ffffff"></path>
              </g></svg>
          ),
        },
         {
          id: `coln-1-Categories`,
          label: 'Assignments',
          path: '/management/e-applications/lms/assignments',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M3 8.5C3 7.67157 3.67157 7 4.5 7H13V10H4.5C3.67157 10 3 9.32843 3 8.5V8.5Z" fill="#ffffff"></path>
                <path d="M14 7H19.5C20.3284 7 21 7.67157 21 8.5V8.5C21 9.32843 20.3284 10 19.5 10H14V7Z" fill="#ffffff"></path>
                <path d="M3 12.5C3 11.6716 3.67157 11 4.5 11H10V14H4.5C3.67157 14 3 13.3284 3 12.5V12.5Z" fill="#ffffff"></path>
                <path d="M11 11H19.5C20.3284 11 21 11.6716 21 12.5V12.5C21 13.3284 20.3284 14 19.5 14H11V11Z" fill="#ffffff"></path>
                <path d="M3 16.5C3 15.6716 3.67157 15 4.5 15H16V18H4.5C3.67157 18 3 17.3284 3 16.5V16.5Z" fill="#ffffff"></path>
                <path d="M17 15H19.5C20.3284 15 21 15.6716 21 16.5V16.5C21 17.3284 20.3284 18 19.5 18H17V15Z" fill="#ffffff"></path>
              </g></svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Certificates',
          path: '/management/e-applications/lms/certificates',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.143 25.143" fill="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g>
                <path fill="#ffffff" d="M18.313,21.852c0.188,0.03,0.38-0.016,0.534-0.129c0.152-0.11,0.258-0.28,0.286-0.469l0.169-1.123 c0.034-0.226,0.175-0.418,0.379-0.521l1.017-0.508c0.172-0.087,0.301-0.236,0.359-0.417c0.06-0.183,0.041-0.379-0.045-0.549 l-0.524-1.013c-0.103-0.198-0.103-0.439,0-0.639l0.524-1.012c0.086-0.17,0.104-0.366,0.045-0.549 c-0.059-0.182-0.188-0.33-0.359-0.417l-1.017-0.508c-0.204-0.103-0.345-0.295-0.379-0.521l-0.169-1.123 c-0.028-0.189-0.134-0.358-0.286-0.468c-0.154-0.114-0.346-0.16-0.534-0.129l-1.125,0.188c-0.223,0.037-0.449-0.037-0.609-0.198 l-0.799-0.812c-0.135-0.135-0.316-0.211-0.508-0.211c-0.189,0-0.374,0.077-0.508,0.211l-0.799,0.812 c-0.159,0.162-0.386,0.235-0.609,0.198l-1.123-0.185c-0.188-0.031-0.38,0.015-0.535,0.129c-0.153,0.11-0.258,0.279-0.286,0.468 l-0.168,1.123c-0.035,0.226-0.175,0.418-0.379,0.521l-1.018,0.508c-0.169,0.087-0.3,0.235-0.358,0.417 c-0.059,0.183-0.042,0.379,0.044,0.549l0.524,1.012c0.104,0.199,0.104,0.44,0,0.639l-0.524,1.013 c-0.086,0.17-0.103,0.366-0.044,0.549c0.059,0.181,0.188,0.33,0.358,0.417l1.018,0.508c0.204,0.103,0.344,0.295,0.379,0.521 l0.168,1.123c0.028,0.188,0.133,0.358,0.286,0.469c0.154,0.113,0.346,0.159,0.535,0.129l1.123-0.185 c0.223-0.039,0.45,0.036,0.609,0.197l0.799,0.81c0.135,0.138,0.318,0.214,0.508,0.214c0.191,0,0.374-0.076,0.508-0.214l0.799-0.81 c0.16-0.161,0.387-0.236,0.609-0.197L18.313,21.852z M15.271,21.032c-2.39,0-4.333-1.943-4.333-4.332s1.944-4.334,4.333-4.334 c2.39,0,4.333,1.946,4.333,4.334S17.662,21.032,15.271,21.032z"></path>
                <path fill="#ffffff" d="M15.272,12.991c-2.041,0-3.703,1.66-3.703,3.702s1.663,3.702,3.703,3.702 c2.043,0,3.703-1.66,3.703-3.702S17.315,12.991,15.272,12.991z"></path>
                <path fill="#ffffff" d="M21.725,22.663l-2.015-2.016l-0.102,0.68c-0.048,0.313-0.222,0.602-0.479,0.787 c-0.255,0.186-0.574,0.265-0.892,0.213l-1.126-0.184c-0.093-0.006-0.149,0.02-0.19,0.062l-0.192,0.193l2.632,2.631 c0.102,0.102,0.249,0.138,0.385,0.097c0.136-0.043,0.236-0.156,0.264-0.297l0.237-1.277l1.281-0.24 c0.14-0.026,0.253-0.127,0.294-0.264C21.864,22.911,21.826,22.762,21.725,22.663z"></path>
                <path fill="#ffffff" d="M13.469,22.138l-1.16,0.189c-0.325,0.05-0.64-0.028-0.896-0.216 c-0.255-0.184-0.429-0.472-0.477-0.787l-0.102-0.677L8.82,22.663c-0.1,0.1-0.137,0.248-0.096,0.384 c0.043,0.137,0.157,0.236,0.295,0.264l1.28,0.239l0.24,1.279c0.026,0.141,0.127,0.254,0.263,0.297 c0.135,0.041,0.283,0.005,0.383-0.096l2.631-2.632l-0.192-0.194C13.582,22.161,13.526,22.138,13.469,22.138z"></path>
                <path fill="#ffffff" d="M16.42,4.217H6.985c-0.34,0-0.615,0.275-0.615,0.615C6.369,5.174,6.644,5.448,6.985,5.448h9.435 c0.339,0,0.615-0.274,0.615-0.614C17.035,4.494,16.758,4.217,16.42,4.217z"></path>
                <path fill="#ffffff" d="M16.42,7.371H6.985c-0.34,0-0.615,0.275-0.615,0.613C6.369,8.324,6.644,8.6,6.985,8.6h9.435 c0.339,0,0.615-0.274,0.615-0.615C17.035,7.646,16.758,7.371,16.42,7.371z"></path>
                <path fill="#ffffff" d="M9.872,20.216l-0.465-0.232c-0.119-0.06-0.227-0.137-0.327-0.223H5.108 c-0.272,0-0.493-0.222-0.493-0.492V1.804c0-0.273,0.221-0.494,0.493-0.494h13.218c0.271,0,0.493,0.221,0.493,0.494v9.007 c0.22,0.052,0.43,0.148,0.614,0.285c0.36,0.257,0.609,0.668,0.676,1.116l0.02-10.407C20.131,0.81,19.321,0,18.326,0H5.108 C4.113,0,3.303,0.811,3.303,1.805v17.466c0,0.996,0.811,1.806,1.805,1.806h3.905L9.872,20.216z"></path>
              </g> </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Certified Users',
          path: '/management/e-applications/lms/certified-users',
          isEnabled: true,
          svg: (
            <svg fill="#ffffff" className="h-5 w-5 fill-current mr-2" viewBox="0 0 32 32" id="icon" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" stroke-width="0.32">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <polygon fill="#ffffff" points="25 10 26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10"></polygon>
                <path d="M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"></path>
                <path d="M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"></path>
              </g>
            </svg>
          ),
        },
        {
          id: `main-menu-2-all`,
          path: '/management/e-applications/onesp/trainers',
          label: 'Trainers',
          Description: '',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g> <g>
                <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
                <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
              </g> </g> </g> </g>
            </svg>
          ),
          subMenu: [],
        },
      ],
    },
    {
      id: `main-menu-2-all`,
      path: '/management/onesp/program-hub/programs',
      label: 'Program Hub',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `coln-1-Categories`,
          label: 'Programs',
          path: '/management/onesp/program-hub/programs',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Subscriptions',
          path: '/management/onesp/program-hub/subscriptions',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },
        {
          id: `coln-1-Categories`,
          label: 'Mentors',
          path: '/management/e-applications/onesp/mentors',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g fill="#ffffff">
                <path d="M3.05 4.75a.7.7 0 01.7-.7h3.5a.7.7 0 110 1.4h-3.5a.7.7 0 01-.7-.7zM3.75 7.05a.7.7 0 100 1.4h2.5a.7.7 0 100-1.4h-2.5z"></path>
                <path fill-rule="evenodd" d="M0 3.25A2.25 2.25 0 012.25 1h6.5c.883 0 1.648.51 2.016 1.25h.984c.698 0 1.3.409 1.582 1h.918c.966 0 1.75.784 1.75 1.75v6a1.75 1.75 0 01-1.75 1.75h-.918c-.281.591-.884 1-1.582 1h-.984A2.25 2.25 0 018.75 15h-6.5A2.25 2.25 0 010 12.75v-9.5zm13.5 8h.75a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25h-.75v6.5zm-2.5 1v-8.5h.75A.25.25 0 0112 4v8a.25.25 0 01-.25.25H11zM2.25 2.5a.75.75 0 00-.75.75v9.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-9.5a.75.75 0 00-.75-.75h-6.5z" clip-rule="evenodd"></path>
              </g> </g>
            </svg>
          ),
        },

      ],
    },

    {
      id: `main-menu-2-all`,
      path: '/management/onesp/membership',
      label: 'Membership',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [],
    },
    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/one-taxonomy/domains',
      label: 'ONE Taxonomy',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [
        {
          id: `main-menu-2-all`,
          path: '/management/dbn-cloud/one-taxonomy/domains',
          label: 'Domains',
          Description: '',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g> <g>
                <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
                <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
              </g> </g> </g> </g>
            </svg>
          ),
          subMenu: [],
        },

        {
          id: `main-menu-2-all`,
          path: '/management/dbn-cloud/one-taxonomy/categories',
          label: 'Categories',
          Description: '',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g> <g>
                <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
                <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
              </g> </g> </g> </g>
            </svg>
          ),
          subMenu: [],
        },

      ],
    },

    {
      id: `main-menu-2-all`,
      path: '/management/dbn-cloud/global-community',
      label: 'Global',
      Description: '',
      isEnabled: true,
      svg: (
        <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier"> <g> <g> <g>
            <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
            <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
          </g> </g> </g> </g>
        </svg>
      ),
      subMenu: [

        {
          id: `main-menu-2-all`,
          path: '/management/dbn-cloud/global-community',
          label: 'Global Community',
          Description: '',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g> <g>
                <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
                <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
              </g> </g> </g> </g>
            </svg>
          ),
          subMenu: [],
        },
        {
          id: `main-menu-2-all`,
          path: '/management/dbn-cloud/global-event',
          label: 'Global Event',
          Description: '',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g> <g>
                <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
                <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
              </g> </g> </g> </g>
            </svg>
          ),
          subMenu: [],
        },

        {
          id: `main-menu-2-all`,
          path: '/management/dbn-cloud/global-program',
          label: 'Global Program',
          Description: '',
          isEnabled: true,
          svg: (
            <svg className="h-5 w-5 fill-current mr-2" fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 491 491">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <g> <g> <g>
                <path d="M470,0.622H20.8c-11.5,0-20.8,9.4-20.8,20.8v313.7c0,11.5,9.4,20.8,20.8,20.8h124.3l-94.5,99.2 c-7.4,8.3-7.5,21.8,0.8,29.2c8.3,7.4,21.8,7.5,29.2-0.8l121.4-127.6c0.2-0.3,0.1-0.1,0,0h87.1l119.5,128.1 c8.3,8.3,20.8,8.3,29.2,1c8.3-8.3,8.3-20.8,1-29.2l-93.4-99.9h123.7c11.5,0,20.8-9.4,21.9-19.8v-314.6 C490.9,10.022,481.5,0.622,470,0.622z M449.2,315.422H40.6v-274.1h408.6V315.422z"></path>
                <path d="M201.9,356.122C201.8,356.222,201.6,356.422,201.9,356.122L201.9,356.122z"></path>
              </g> </g> </g> </g>
            </svg>
          ),
          subMenu: [],
        },


      ],
    },
  ]
})
